// gloss
export const FORUM_RICH_TEXT_TAGS = [
  'p',
  'br',
  'b',
  'i',
  'em',
  'strong',
  'strike',
  'ul',
  'ol',
  'li',
  'div',
  'span',
  'a',
  'img',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'blockquote',
  'code',
  'pre',
  'hr',
  // why: iframe is deliberately excluded — a direct DOMPurify caller bypassing
  // why: sanitizeForumPostHtml passes iframes with no host/sandbox check.
] as const;

// gloss
export const FORUM_RICH_TEXT_ATTRS = [
  'class',
  'style',
  'href',
  'target',
  'rel',
  'src',
  'alt',
  'title',
  'data-*',
] as const;

export const FORUM_SANITIZE_CONFIG = {
  ALLOWED_TAGS: [...FORUM_RICH_TEXT_TAGS],
  ALLOWED_ATTR: [...FORUM_RICH_TEXT_ATTRS],
};
